module.exports = __webpack_public_path__ + "static/media/livello9-logo-lettering-dark.192bb1ef.svg";